import { render, staticRenderFns } from "./OfficeTypeSelector.vue?vue&type=template&id=6d1324c2&"
import script from "./OfficeTypeSelector.vue?vue&type=script&lang=js&"
export * from "./OfficeTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports